import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { investSystems } from '../../data/invest';
import { fadeUp } from '../../utils/motion';
export function InvestSystems() {
  return <section className="bg-white py-20 lg:py-28" data-id="element-1381" data-mp="str8nr89mjgm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1382" data-mp="xtm0bwzv7d2q">
        <motion.h2 {...fadeUp} className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight mb-12" data-id="element-1383" data-mp="xs2m0bxrrc3l">
          Our systems and frameworks
        </motion.h2>
        <div className="border-b border-line" data-id="element-1384" data-mp="nxamh2kmmf66">
          {investSystems.map(system => <motion.article key={system.name} {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 border-t border-line py-12" data-id="element-1385" data-mp="a1yi03go5ac2">
              <div className="lg:col-span-5" data-id="element-1386" data-mp="87ub0sd93xf">
                <p className="text-sm font-medium text-teal mb-2" data-id="element-1387" data-mp="5583vlofcota">{system.role}</p>
                <h3 className="font-heading font-bold text-2xl lg:text-3xl text-ink-dark mb-5" data-id="element-1388" data-mp="3lf8tom6svsfb">{system.name}</h3>
                <a href={system.link} className="inline-flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1389" data-mp="3ghgqgw0pgjvt">
                  {system.linkLabel}
                  <ArrowRight size={16} aria-hidden="true" data-id="element-1390" data-mp="31rrcg07ikle4" />
                </a>
              </div>
              <div className="lg:col-span-7 space-y-5" data-id="element-1391" data-mp="2xq650udr0zbb">
                {system.paragraphs.map((paragraph, index) => <p key={paragraph} className={`leading-relaxed ${index === 0 ? 'text-xl text-ink-dark' : 'text-lg text-ink-muted'}`} data-id="element-1392" data-mp="3bi42g7y3l6rn" data-mpi={index}>
                    {paragraph}
                  </p>)}
                {system.status && <p className="inline-block text-sm font-medium text-navy bg-surface-muted border border-line rounded-md px-3 py-1.5" data-id="element-1393" data-mp="2e2ymckdkp7rf">
                    {system.status}
                  </p>}
                {system.note && <p className="text-base text-ink-dark leading-relaxed bg-surface-bg border-l-2 border-teal px-5 py-4 rounded-r-md" data-id="element-1394" data-mp="mw284cl3oalx">
                    {system.note}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}